module.exports = __webpack_public_path__ + "static/img/15.81ccf6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/zh/15.png
// module id = GBBv
// module chunks = 0